import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BagHistory } from '../bag-history.model';

@Injectable({
	providedIn: 'root',
})
export class BagHistoryApiService {
	private readonly httpClient = inject(HttpClient);
	private readonly apiUrl = environment.apiUrl;

	getHistory(requestUrl: string): Observable<BagHistory[]> {
		return this.httpClient.get<BagHistory[]>(`${this.apiUrl}/${requestUrl}/history_diff/`);
	}
}
